<template>
  <v-select label="Type" :items="types" autocomplete :value="value" @input="$emit('input', $event)" item-text="name" item-value="name"></v-select>
</template>

<script>
export default {
  slots: ["value", "types"]
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TypeSelect.vue